module.exports = __webpack_public_path__ + "src/img/next-generation/feature-large.ec369.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/next-generation/feature-large.jpg
// module id = 245
// module chunks = 0